export default "__VITE_ASSET__BM0P53FK__"